import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dig from 'spiceutils/dist/dig';

import Section from 'components/Section';

import PinToBoardModal from 'components/PinToBoardModal';

import CdfRadioButtons from '../../components/FormControls/CdfRadioButtons';
import AnswersToShow from '../../components/FormControls/AnswersToShow';
import Country from '../../components/FormControls/Country';
import BreakGroupBreakAnswer from '../../components/FormControls/BreakGroup_BreakAnswer';
import CountryList from '../../components/FormControls/CountryList';
import BreakList from '../../components/FormControls/BreakList';
import IncludeBacksheets from '../../components/FormControls/IncludeBacksheets';

import Chart from '../../components/Chart';
import DownloadNotification from '../../components/DownloadNotifications';

const DatatoolSlim = (props) => (
  <Container>
    <Form>
      <h3>Configure Chart</h3>
      <Section title="Filters" initialOpen>
        <Country controlList={props.controlList} cdf={props.cdf} updateCDF={props.updateCDF} />
        <CountryList cdf={props.cdf} controlList={props.controlList} updateCDF={props.updateCDF} />
        <BreakList cdf={props.cdf} controlList={props.controlList} updateCDF={props.updateCDF} />
        <BreakGroupBreakAnswer controlList={props.controlList} cdf={props.cdf} updateCDF={props.updateCDF} />
      </Section>

      <Section title="Advanced">
        <AnswersToShow controlList={props.controlList} cdf={props.cdf} updateCDF={props.updateCDF} />
        <CdfRadioButtons type="Adjusted" label="Adjusted" options={[{ value: undefined, text: 'Default' }, { value: true, text: 'Adjusted' }, { value: false, text: 'Reported' }]} cdf={props.cdf} updateCDF={props.updateCDF} controlList={props.controlList} />
        <CdfRadioButtons
          type="AgeFilter"
          label="Age filter"
          options={dig(
            props.controlList,
            'AgeFilter',
            'Options',
            {
              map: (text, index) => ({
                text,
                value: [undefined, 'All', '16-64'][index],
              }),
            }
          ) || []}
          cdf={props.cdf}
          updateCDF={props.updateCDF}
          controlList={props.controlList}
        />
        <IncludeBacksheets cdf={props.cdf} updateCDF={props.updateCDF} />
      </Section>
    </Form>
    <ChartResult>
      <PinToBoardModal>
        <Chart updateCDF={props.updateCDF} cdf={props.cdf} />
      </PinToBoardModal>
    </ChartResult>
    <DownloadNotification />
  </Container>
);

DatatoolSlim.propTypes = {
  controlList: PropTypes.object.isRequired,
  cdf: PropTypes.object.isRequired,
  updateCDF: PropTypes.func.isRequired,
};

export const Container = styled.div`
  background-color: #ffffff;
  height: calc(100vh - 80px);
  display: flex;
  align-items: stretch;
`;

const Panel = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
`;

export const ChartResult = styled(Panel)`
  flex: 13;
  position: relative;
  padding-bottom: 20px;
`;

export const Form = styled(Panel)`
  flex: 4.8;
  display: inline-block;
  border-right: 1px solid #e4e4e4;
  padding: 20px;
`;

export default DatatoolSlim;



// WEBPACK FOOTER //
// ./app/containers/DatatoolSlim/index.js